<div class="service-card" [class.service-card--disabled]="disabled()" (click)="onCardClick()" role="button" tabindex="0">
  <!-- Image -->
  <div class="service-card__image-wrapper">
    @if (imageUrl()) {
      <img
        [src]="imageUrl()"
        [alt]="title()"
        class="service-card__image"
      />
    } @else if (initials()) {
      <div class="service-card__initials">
        {{ initials() }}
      </div>
    } @else {
      <div class="service-card__image-placeholder">
        <mat-icon>image</mat-icon>
      </div>
    }
  </div>

  <!-- Content -->
  <div class="service-card__content">
    <span class="service-card__title">{{ title() || 'Service Title' }}</span>
    @if (description()) {
      <span class="service-card__description" [title]="description()">{{ description() }}</span>
    }

    <!-- Badge -->
    @if (badgeText()) {
      <div class="service-card__badge">
        <span>{{ badgeText() }}</span>
      </div>
    }
  </div>
</div>
